import css from 'styled-jsx/css'
import { colors } from '../../styles'

export default css`
:global(.swiper) {
  z-index: 1 !important;
}

:global(.swiper-button-prev),
:global(.swiper-button-next) {
  top: 45%;
  width: 52px;
  height: 62px
}
:global(.swiper-slide-active) {
  transform: translateZ(1px);
  transition: transform 450ms ease-in-out;
}
:global(.swiper-slide) {
  -webkit-backface-visibility: hidden;
 -webkit-transform: translateZ(0px);
  }
  :global(.swiper-wrapper){
  -webkit-transform-style: preserve-3d;
  }

:global(.swiper-button-prev:hover),
:global(.swiper-button-next:hover) {
  -webkit-transform: scale(1.055);
    -ms-transform: scale(1.055);
    transform: scale(1.055);
    text-shadow: 0px 0px 8px #fff
}

:global(.swiper-button-prev::after), :global(.swiper-button-next::after) {
  font-size: 28px;
  font-weight: bold;
  color: #c4c4c4;
}

:global(.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal) {
  position: absolute;
  width: fit-content;
  margin: 0 auto;
  right: 3%;
  bottom: 21%;
}

:global(.swiper-pagination-bullet) {
  height: 12px;
  width: 12px;
  margin-left: 6px !important;
  margin-right: 6px !important;
}


:global(.swiper-pagination-bullet) {
  background: ${colors.secondaryText};
  opacity: 0.5;
}

:global(.swiper-pagination-bullet-active) {
  fill: var(--white-01-f-6-f-6-f-6, ${colors.primaryText});
  filter: drop-shadow(0px 0px 5px rgba(255, 255, 255, 0.50));
  background: ${colors.primaryText};
  opacity: 1;
}

.hero-container {
  aspect-ratio: 16 / 9;
}
@media (min-width: 767px) {
:global(.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal) {
  position: absolute;
  width: unset;
  right: 3%;
  bottom: 4%;
}
}
@media (min-width: 1200px) {
  :global(.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal) {
    position: absolute;
    width: fit-content;
    margin: 0 auto;
    right: 3%;
    bottom: 21%;
    display: flex;
    padding-left: 48px;
  }

  :global(.swiper-button-prev) {
    left: -10px;
  }
  :global(.swiper-button-next) {
    right: -10px;
  }
  :global(.swiper-slide) {
    padding-left: 48px;
  }
}

@media (max-width: 1199px) {
  :global(.swiper-button-prev), :global(.swiper-button-next) {
    display: none
  }
}

@media (max-width: 767px) {
  :global(.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal) {
    position: relative;
    padding-bottom: 5%;
    padding-top: 5%;
    right: unset;
  }

  .hero-container {
   aspect-ratio: 1 / 1;
  }
}

@media (max-width: 520px) {
  :global(.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal) {
    padding-top: 0px;
  }
}
`
